import { ForumLike, FORUMS_COLLECTION, FORUMS_LIKES_COLLECTION, FORUMS_LIKE_TIMESTAMP_FIELD } from "../../db";
import { FirestoreDatabase as Database, FirestoreTimestampServerValue } from "../../db/common";
import { BaseFirestoreService } from "../FirestoreService";

/**
 * Forum Service for the likes on a post
 */
export class ForumPostLikesService extends BaseFirestoreService<ForumLike> {
    constructor(protected db: Database, protected postId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${FORUMS_COLLECTION}/${this.postId}/${FORUMS_LIKES_COLLECTION}`;
    }

    //@overwrite no need to specify some args
    create(data: Omit<ForumLike, typeof FORUMS_LIKE_TIMESTAMP_FIELD>): Promise<string> {
        return super.create({
            ...data,
            timestamp: FirestoreTimestampServerValue,
        }, data.author.id);//Note: the duplication check is made by using the author id as doc id
    }
}
